/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	AuthSetPasswordByInvitationRequest,
	AuthSetPasswordByInvitationResponse,
} from '../types/AuthSetPasswordByInvitation'

/**
 * POST /auth/set-password-by-invitation
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::setPasswordByInvitation
 */
export async function authSetPasswordByInvitation(
	data: AuthSetPasswordByInvitationRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthSetPasswordByInvitationResponse>> {
	return axiosInstance.post('/auth/set-password-by-invitation', data, config)
}
